

import { Component, Prop, VModel, Vue } from 'vue-property-decorator';
import PaymentRequirementsIncomingHandlerDialog from './PaymentRequirementsIncomingHandlerDialog.vue';
import PaymentRequirementsListDialog from './PaymentRequirementsListDialog.vue';

@Component({
	components: {
		PaymentRequirementsIncomingHandlerDialog,
		PaymentRequirementsListDialog,
	}
})
export default class PaymentRequirementsIncomingCheckerDialog extends Vue {

	@VModel({ type: Boolean })
	paymentRequirementsListDialog!: boolean

	@Prop(Function)
	saveOperationToDraft!: () => Promise<any> 

	paymentRequirementsConfirmDialog: boolean = false

	onConfirmPaymentRequirementsList() {
		this.paymentRequirementsListDialog = false;
		this.paymentRequirementsConfirmDialog = true;
	}

}

